/**
 * API Services pour la gestion 2FA
 * RÉUTILISABILITÉ : 100% - TypeScript pur
 */

import { apiClient } from '@shared/infrastructure/http';
import { getAuthConfig } from '../../config/authConfig';
import type {
  ApiResponse,
  Activate2FAData,
  Activation2FAResult,
  Deactivate2FAData,
  Generate2FASecretData,
  Secret2FAResult,
} from '../../application/dto/dtos';

/**
 * Service 2FA
 */
export const twoFactorApi = {
  
  /**
   * Activer l'authentification à deux facteurs
   */
  async activate(data: Activate2FAData): Promise<ApiResponse<Activation2FAResult>> {
    const config = getAuthConfig();
    return apiClient.post<Activation2FAResult>(config.endpoints.activate2FA, data);
  },

  /**
   * Désactiver l'authentification à deux facteurs
   */
  async deactivate(data: Deactivate2FAData): Promise<ApiResponse<void>> {
    const config = getAuthConfig();
    return apiClient.post<void>(config.endpoints.deactivate2FA, data);
  },

  /**
   * Générer un secret 2FA (pour TOTP app authenticator)
   */
  async generateSecret(data: Generate2FASecretData): Promise<ApiResponse<Secret2FAResult>> {
    const config = getAuthConfig();
    return apiClient.post<Secret2FAResult>(config.endpoints.generate2FASecret, data);
  },

  /**
   * Envoyer un code 2FA par email
   */
  async sendCode(idUtilisateur: string): Promise<ApiResponse<{ expiresIn: number }>> {
    const config = getAuthConfig();
    return apiClient.post<{ expiresIn: number }>(config.endpoints.send2FACode, { idUtilisateur });
  },

  /**
   * Vérifier un code backup (pendant le flux de connexion 2FA)
   * Le backend attend idUtilisateur (UUID) + code (12 alphanumériques)
   */
  async verifyBackupCode(data: {
    idUtilisateur: string;
    code: string;
  }): Promise<ApiResponse<{ codeValide: boolean }>> {
    const config = getAuthConfig();
    return apiClient.post<{ codeValide: boolean }>(config.endpoints.verifyBackupCode, {
      idUtilisateur: data.idUtilisateur,
      code: data.code,
    });
  },

  /**
   * Générer de nouveaux codes de backup (remplace les anciens)
   */
  async generateBackupCodes(idUtilisateur: string): Promise<ApiResponse<{ codes: string[] }>> {
    const config = getAuthConfig();
    return apiClient.post<{ codes: string[] }>(config.endpoints.generateBackupCodes, { idUtilisateur });
  },
};
